import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetSupportCategory(data = {}) {
  const { enabled = false, config = {}, queryKey = ['support-category'] } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const getCategory = () => privateFetch.get('/v1/admin/support/category', { params });

  return useQuery(queryKey, getCategory, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetSupportCategory;
